/** SpeedRailz map promo sheet / panel title (two lines in UI). */
export const SPEEDRAILZ_SHEET_TITLE_LINE1 = "The ATX Pull-Up Challenge";
export const SPEEDRAILZ_SHEET_TITLE_LINE2 = "presented by Speedrailz";
